export default "__VITE_ASSET__PqEzSWBs__"